import React, { useContext } from 'react';
import addDays from 'date-fns/addDays';
import { formatDistanceStrict } from 'date-fns';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';

import LocaleContext from '../../context/locale';

const hideForSkus = [];

const LeadTime = ({ value, sku, ...props }) => {
  const { t } = useTranslation();
  const locale = get(useContext(LocaleContext), 'dateLocale', null);
  if (value === '0') {
    return <div {...props}>{t('In Stock!')}</div>;
  }

  if (hideForSkus.includes(sku)) {
    return null;
  }

  // adjust lead time for users to account for weekends
  const adjustedLeadTime = value * (7 / 5);

  return (
    <div {...props}>
      {t('Lead time')}:{' '}
      {formatDistanceStrict(addDays(new Date(), adjustedLeadTime), new Date(), {
        locale,
        partialMethod: 'ceil'
      })}
    </div>
  );
};

export default LeadTime;
